import { Component } from '@angular/core';

@Component({
  selector: 'app-page-header-container',
  templateUrl: './page-header-container.component.html',
  styleUrls: [],
  standalone: false,
})
export class PageHeaderContainerComponent {
}
